import type { FC } from 'react';
import { BuildingIcon } from './CourseStudentIcons';

interface StudentOfficialSourcesOverlayProps {
  onBackToCabinet: () => void;
}

export const StudentOfficialSourcesOverlay: FC<StudentOfficialSourcesOverlayProps> = ({
  onBackToCabinet,
}) => {
  const sources = [
    {
      title: 'Официальный портал ЕНУ им. Л.Н. Гумилева',
      desc: 'Главный веб-ресурс университета: новости, приказы, расписание и академическая политика.',
      url: 'https://enu.kz',
      code: 'ENU.KZ',
    },
    {
      title: 'Научная библиотека Отырар',
      desc: 'Электронный каталог, доступ к базам Scopus, Web of Science, SpringerLink и фондам диссертаций.',
      url: 'https://library.enu.kz',
      code: 'LIBRARY',
    },
    {
      title: 'Платонус ЕНУ (Автоматизированная система)',
      desc: 'Автоматизированная информационная система ведомостей, регистрации на дисциплины и транскриптов.',
      url: 'https://platonus.enu.kz',
      code: 'PLATONUS',
    },
    {
      title: 'Академический регламент и правила оценивания',
      desc: 'Положение о балльно-рейтинговой буквенной системе оценки учебных достижений обучающихся.',
      url: '#',
      code: 'RULES',
    },
  ];

  return (
    <div className="space-y-6 pb-12">
      <div className="border border-slate-800 bg-[#081321] rounded-2xl p-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 shadow-xl">
        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={onBackToCabinet}
            className="w-10 h-10 rounded-xl bg-slate-900 border border-slate-700/80 hover:border-cyan-400 text-slate-300 hover:text-cyan-400 flex items-center justify-center transition-all"
            aria-label="Вернуться в кабинет"
          >
            &larr;
          </button>
          <div>
            <p className="text-[11px] uppercase tracking-wider text-cyan-400 font-semibold">
              Официальные источники
            </p>
            <h2 className="text-xl font-bold text-white tracking-wide">Официальные источники ENU</h2>
            <p className="text-xs text-slate-400">
              Подтверждённые ENU-кабинеты, маршруты, ответственные и процедуры.
            </p>
          </div>
        </div>

        <button
          type="button"
          onClick={onBackToCabinet}
          className="px-5 py-2 rounded-xl bg-[#E5A83B] hover:bg-[#D4982E] text-slate-950 text-xs font-bold transition-all shadow-md self-end sm:self-auto"
        >
          Сохранить
        </button>
      </div>

      <div className="p-4 rounded-xl bg-teal-950/40 border border-teal-500/40 text-teal-200 text-xs leading-relaxed">
        Все официальные ссылки и маршруты проверены. Внешние пароли и учётные записи на платформе не сохраняются.
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {sources.map((s) => (
          <div
            key={s.title}
            className="p-5 rounded-2xl bg-[#081321] border border-slate-800 hover:border-teal-500/40 transition-all space-y-3 flex flex-col justify-between"
          >
            <div>
              <div className="flex items-center justify-between">
                <span className="text-[10px] font-bold text-teal-400 uppercase tracking-wider">
                  {s.code}
                </span>
                <div className="w-7 h-7 rounded-lg bg-teal-950/60 border border-teal-700/50 flex items-center justify-center text-teal-400">
                  <BuildingIcon className="w-3.5 h-3.5" />
                </div>
              </div>
              <h4 className="text-base font-bold text-white mt-2">{s.title}</h4>
              <p className="text-xs text-slate-400 mt-1 leading-relaxed">{s.desc}</p>
            </div>

            <div className="pt-3 border-t border-slate-800">
              <a
                href={s.url}
                target="_blank"
                rel="noreferrer noopener"
                className="inline-flex w-full items-center justify-center py-2 rounded-xl border border-teal-500/50 hover:bg-teal-950/30 text-teal-300 text-xs font-semibold transition-all"
              >
                Перейти к ресурсу &rarr;
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
